module.exports = __webpack_public_path__ + "img/logo_icon.bf6a041b.svg";